import { OTHER_CURRENCIES, TOP_CURRENCIES } from '@/app/constants'

export const getCurrencies = () => {
	// Sort other currencies alphabetically by label
	const sortedOtherCurrencies = [...OTHER_CURRENCIES].sort((a, b) =>
		a.label.localeCompare(b.label)
	)

	// Return top currencies first, then sorted other currencies
	return [...TOP_CURRENCIES, ...sortedOtherCurrencies]
}
